/* eslint-disable react/no-danger */
/* eslint-disable no-unused-vars */
/* eslint-disable import/extensions */
/* eslint-disable react/button-has-type */
import { useState } from "react";
import TreeView from "devextreme-react/tree-view";
import { Grid, Stack } from "@mui/material";
import ScrollTop from "components/ScrollTop.js";
import { information } from "./information.js";
import "./popup.css";

/* eslint-disable no-undef */
function NavigationHelp() {
  const [show, toggleShow] = useState(true);
  const [data] = useState(information);
  const [des, setDes] = useState(information[0]);

  const closeModal = () => {
    toggleShow(!show);
    window.location.reload();
  };

  const handleTreeViewSelectionChange = (e) => {
    const vals = e.itemData;
    if (vals) {
      setDes(e.itemData);
    }
  };

  return (
    <>
      <ScrollTop />
      {show && (
        <div className="popup">
          <div className="popup_inner">
            <div className="content">
              <p className="alignleft">
                <h1 style={{ fontFamily: "Roboto" }}>Guía de Uso</h1>
              </p>
              <p className="alignright">
                <button onClick={closeModal} className="closeModal">
                  <span className="material-icons-outlined">close</span>
                </button>
              </p>
            </div>
            <Grid>
              <Grid container>
                <Grid item xs={12} lg={3} style={{ marginTop: "2%" }}>
                  <div className="option">
                    <TreeView
                      dataSource={data}
                      selectionMode="single"
                      selectByClick
                      onItemSelectionChanged={handleTreeViewSelectionChange}
                    />
                  </div>
                </Grid>
                <Grid item xs={12} md={10} lg={8.5}>
                  <Stack>
                    <div
                      style={{
                        marginLeft: "5%",
                        maxWidth: "95%",
                        overflowY: "auto",
                        ml: { xs: -2, lg: "auto" },
                        mt: { xs: 4, lg: 0 },
                        marginTop: "5%",
                        marginRight: "2%",
                        textAlign: "justify",
                        height: "40vh",
                        fontFamily: "Roboto",
                        paddingRight: "25px",
                        color: "#7B809A",
                      }}
                      dangerouslySetInnerHTML={{ __html: des.description }}
                    />
                  </Stack>
                </Grid>
              </Grid>
            </Grid>
          </div>
        </div>
      )}
    </>
  );
}

export default NavigationHelp;
